module.exports = __webpack_public_path__ + "static/ai_event_poster-2d3db30dc33bcdfab3a3125019a8e1e2.jpeg";